import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { commonStyles } from '../styles/styles';
import { firstLetters } from '../utils';

const AvatarCircle = ({ classes, bg, withBorder, size, color, senderName }) => {
  const styles = {
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <div className={classes.senderAvatar} style={styles}>
      <Typography style={{ color: '#fff' }}>
        {senderName !== undefined && firstLetters(senderName)}
      </Typography>
    </div>
  );
};

AvatarCircle.propTypes = {
  classes: PropTypes.instanceOf(Object),
  bg: PropTypes.string,
  withBorder: PropTypes.bool,
  size: PropTypes.number,
  color: PropTypes.string,
  senderName: PropTypes.string,
};

const styles = () => ({
  ...commonStyles,
  senderAvatar: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 15,
    color: '#50E3C2',
    flexShrink: 0,
    marginRight: 7,
    backgroundColor: '#4A4A4A',
  },
});

export default compose(withStyles(styles))(AvatarCircle);
